import styled from '@emotion/styled';
import Card from 'components/Card/Card';
import KizenTypography from 'app/kizentypo';
import Button from 'components/Button';
import { PageContentContainer } from 'components/Layout/PageContentWidth';
import { useTranslation } from 'react-i18next';
import { useSetTitleOnLoad } from 'hooks/useSetTitleOnLoad';
import { useHistory } from 'react-router-dom';

const StyledCard = styled(Card)`
  padding: 25px 0 27px 0;
  margin: 20px 0 0 0;
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  && .not_found_long-text {
    max-width: 382px;
    margin-bottom: 22px;
    text-align: center;
  }

  && h1 {
    margin-top: 2px; //  Design nudge
    margin-bottom: 22px;
    line-height: 1;
  }

  && .not_found_button {
    margin-bottom: 29px;
  }

  && .support_text {
    margin-bottom: 9px;
  }
`;

export default function NotFound({ title }) {
  const { t } = useTranslation();
  const history = useHistory();
  useSetTitleOnLoad(title(t));
  return (
    <PageContentContainer>
      <StyledCard>
        <KizenTypography as="h1" type="hero">
          {t('Page Not Found')}
        </KizenTypography>

        <KizenTypography as="p" className="not_found_long-text">
          {t(
            'The URL was not found. Please check the URL and try again or click the button below to go to home.'
          )}
        </KizenTypography>

        <Button
          color="blue"
          className="not_found_button"
          onClick={() => {
            history.replace('/');
          }}
        >
          {t('Go to Home')}
        </Button>

        <KizenTypography as="p" className="support_text">
          {t('If you need additional help, please email')}{' '}
          <KizenTypography
            type="link-mail"
            size="micro"
            weight="bold"
            href="mailto:support@kizen.com"
          >
            support@kizen.com
          </KizenTypography>
          .
        </KizenTypography>
        <KizenTypography as="p">{t('Error code')}: 404</KizenTypography>
      </StyledCard>
    </PageContentContainer>
  );
}
